import _ from 'lodash';
import { getColor } from 'common/constants/_colors';
import { PROJECTS } from '../services/projects.services';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import PieChart from 'components/PieChart';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { calculatePercentage, getCaseInsensitive } from 'common/utils/utils';
import DeliveryLegend from './DeliveryLegend';
import { DELIVERY_BREAKDOWN, PROJECTS_VIEW_TYPES } from '../projects.consts';
import { getTotalsFromIssuesData } from '../services/projectExtended.services';
import PieBreakdownTooltip from './PieBreakdownTooltip';

const getBreakdownPieData = ({ breakdown, issuesData }) => {
  const totals = getTotalsFromIssuesData(issuesData);
  const pieSum = _.sum(
    Object.entries(totals)
      .filter(([key]) => breakdown.map(({ key }) => key).includes(key))
      .map(item => item[1])
  );

  const pieData = [];
  const legendData = [];
  breakdown.forEach(({ title, key, color }) => {
    const value = getCaseInsensitive(totals, `${[key]}`, 0);

    pieData.push({
      color: getColor(color),
      key,
      value
    });

    legendData.push({
      color,
      name: title,
      key,
      subValue: `(${calculatePercentage(value, pieSum)}%)`,
      value
    });
  });
  return { pieData, pieSum, legendData };
};

const DeliveryPieBreakdown = ({
  issuesData,
  breakdownType,
  setSelectedDeliveryState,
  isSingleIterationView,
  displayType,
  isPulse
}) => {
  const { breakdown = [], title } = DELIVERY_BREAKDOWN[breakdownType];
  const { pieData, pieSum, legendData } = getBreakdownPieData({
    breakdown,
    issuesData
  });

  switch (displayType) {
    case PROJECTS_VIEW_TYPES.EXTENDED_PIE_VIEW:
      return (
        <Flex pr='small' data-testid='extended-view-pie-breakdown'>
          <Flex>
            <PieChart
              data={pieData}
              dataKey='value'
              pieSize={PROJECTS.LARGE_PIE_SIZE}
              customTooltip={<PieBreakdownTooltip legendData={legendData} />}
              noStroke={true}
              {...(isSingleIterationView
                ? {
                    onCellClick: pieCell => {
                      const deliveryState = _.get(pieCell, 'key', '');

                      setSelectedDeliveryState(deliveryState);
                      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                        page: isPulse
                          ? TRACKING.PAGES.PULSE
                          : TRACKING.PAGES.PROJECTS,
                        click_type: TRACKING.CLICK.PDT_PIE_DELIVERY_TYPE_SELECT,
                        selected_delivery_type: deliveryState
                      });
                    }
                  }
                : {})}
            />
          </Flex>
          <Flex direction='column' minWidth='6rem'>
            <Flex direction='column' pl='normal' pb='small'>
              <Text size='x-x-large'>{pieSum}</Text>
              <Flex pt='x-x-x-small'>
                <Text size='small' color='shuttleGray'>
                  {title}
                </Text>
              </Flex>
              <Flex pt='small'>
                <Text size='x-small' color='shuttleGray'>
                  <i>Hover for details</i>
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      );
    case PROJECTS_VIEW_TYPES.ITERATION_VIEW:
      return (
        <Flex pr='small' data-testid='iteration-tooltip-pie-breakdown'>
          <div>
            <PieChart
              data={pieData}
              dataKey='value'
              pieSize={PROJECTS.MEDIUM_PIE_SIZE}
              showTooltip={false}
              noStroke={true}
              innerTextComponent={() => (
                <Text
                  size='medium'
                  weight='500'
                  data-testid='iteration-tooltip-pie-breakdown-inner-text'
                >
                  {pieSum}
                </Text>
              )}
            />
          </div>
          <Flex direction='column'>
            <Text size='small' pl='1.5rem' pb='1rem'>
              {title}
            </Text>
            <DeliveryLegend
              issuesData={legendData}
              isLegendHorizontal={false}
              showTitleEllipsisAfter={false}
            />
          </Flex>
        </Flex>
      );
    default:
      return <></>;
  }
};

export default DeliveryPieBreakdown;
